import { render, staticRenderFns } from "./domisili.vue?vue&type=template&id=d644f306&"
import script from "./domisili.vue?vue&type=script&lang=js&"
export * from "./domisili.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports